module.exports = __webpack_public_path__ + "icon-visualization-setstar.svg?f3f15068accadbc0069025528a6f9aa7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-visualization-setstar.svg
// module id = 523
// module chunks = 0